import { render } from "./tool_search.vue?vue&type=template&id=005a20d0&scoped=true"
import script from "./tool_search.vue?vue&type=script&lang=js"
export * from "./tool_search.vue?vue&type=script&lang=js"

import "./tool_search.vue?vue&type=style&index=0&id=005a20d0&lang=scss&scoped=true"
import "./tool_search.vue?vue&type=style&index=1&id=005a20d0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005a20d0"]])

export default __exports__